/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import { taskFor } from 'ember-concurrency-ts';

class StandaloneGuidanceV2Route extends Route {
  @service declare reportingMetrics: ReportingMetrics;

  analytics = {
    section: 'standalone',
    place: 'standalone.guidance-v2',
  };

  async beforeModel() {
    await taskFor(this.reportingMetrics.setup).perform();
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneGuidanceV2Route, {
  overrideRenderTemplate: false,
});
